"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var faqQuestion_1 = require("./backbone/views/faqQuestion");
$(function () {
    return $('.js-question').each(function () {
        new faqQuestion_1.ViewFaqQuestion({ el: this });
    });
});
